import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL

class InstituteApi {
  getClaimRequestInstitution(config){
    return axios.get(BASE_URL + "/admin/institution/claim-request-institution", config)
  }
    getInstituteById(businessId, config){
      return axios.get(BASE_URL + `/admin/institution/get-institution-by-id/${businessId}`, config)
    }
    getAllBusinessUser(config){
      return axios.get(BASE_URL + "/admin/institution/get-all-business-users", config)
    }
    verifyInstitutionDocument(businessId, data, config){
      return axios.post(BASE_URL + `/admin/institution/verify-institution-document/${businessId}`, data, config)
    }

    verifyBusinessUser(businessId, data, config){
      return axios.post(BASE_URL + `/admin/institution/verify-business-account/${businessId}`, data, config)
    }


  institutionList(config){
    return axios.get(BASE_URL + "/admin/institution/getInstitutionList", config)
  }

  updateInstitutionStatus(data, config) {
    return axios.put(
      BASE_URL + "/admin/institutionList/updateInstitutionStatus",
      data,
      config
    )
  }
}

const instituteApi = new InstituteApi()
export default instituteApi
